import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#FFD700", //  yellow color
    },
    secondary: {
      main: "#000000", //  black color
    },
  },
  typography: {
    fontFamily: "Copernicus, sans-serif",
  },
});

export default theme;
